<template>
  <ModalStructure
    shouldCloseOnBlur
    :showModal="shouldShow"
    @close="handleBlur"
  >
    <template v-slot:header>
      <HeadingSmall>
        You’re Growing with JumpCloud!
      </HeadingSmall>
    </template>
    <template v-slot:body>
      <div
        class="growingWithJumpCloudModal"
      >
        <img
          alt="Growing with JumpCloud?"
          class="modalImage"
          src="img/Payments/growing-with-jc-graphic.png"
        >
        <ParagraphBody>
          Adding another user moves your organization out of being a free account.
          Explore pricing options to figure out which plan could work for you!
        </ParagraphBody>
      </div>
    </template>
    <template v-slot:footer>
      <div
        class="buttonRow"
      >
        <ButtonSecondary
          :data-test-id="$testId('ctaButton')"
          text="Go to Pricing"
          @click="handleCtaClicked"
        />
        <Button
          :data-test-id="$testId('cancelButton')"
          hasNoBackground
          text="I'm not Ready"
          @click="handleCancelClicked"
        />
      </div>
    </template>
  </ModalStructure>
</template>

<script>
import {
  Button,
  ButtonSecondary,
  HeadingSmall,
  ModalStructure,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import {
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import Util from 'client/util/Util';

const {
  description,
  location,
  section,
  text,
} = eventProperties;

export default {
  name: 'GrowingWithJumpCloudModal',

  components: {
    Button,
    ButtonSecondary,
    HeadingSmall,
    ModalStructure,
    ParagraphBody,
  },

  props: {
    location: {
      required: true,
      type: String,
    },
    shouldShow: Boolean,
  },

  methods: {
    closeModal() {
      this.$emit('update:shouldShow', false);
    },

    handleBlur() {
      EventHelper.triggerButtonClicked({
        [description]: 'user canceled the paywall modal by clicking outside modal',
        [location]: this.location,
        [section]: 'Paywall Modal',
      });
      this.closeModal();
    },

    handleCancelClicked() {
      EventHelper.triggerButtonClicked({
        [description]: 'user canceled the paywall modal by clicking cancel button',
        [location]: this.location,
        [section]: 'Paywall Modal',
        [text]: "I'm Not Ready",
      });
      this.closeModal();
    },

    handleCtaClicked() {
      EventHelper.triggerButtonClicked({
        [description]: 'user navigated to pricing page upon seeing paywall',
        [location]: this.location,
        [section]: 'Paywall Modal',
        [text]: 'Go To Pricing',
      });
      this.closeModal();
      Util.redirect('#/pricing');
    },
  },
};
</script>

<style scoped>
  .buttonRow {
    display: flex;
    gap: var(--jc-spacer);
  }

  .growingWithJumpCloudModal {
    display: flex;
    flex-direction: column;
  }

  .modalImage {
    align-self: center;
    height: auto;
    margin-bottom: var(--jc-spacer-medium);
    width: 15rem;
  }
</style>
